import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../../contexts/AppContext";
import { Form } from "antd";
import GeneralButton from "../../../components/GeneralButton/GeneralButton";
import ReservationInputForm from "../../../forms/ReservationInputForm/ReservationInputForm";
import { showToast } from "../../../utils/commonUtils";
import {
  updateFamilyInfo,
  registFamilyInfo,
  deleteFamilyInfo,
  getFamilyInfo,
} from "../../../services/service";
import "../../../styles/globals.css";
import "./FamilySettingPage.css";
import dayjs from "dayjs";
import Dialog from "../../../components/Dialog/Dialog";

/**
 * 家族情報登録画面用のコンポーネント
 * @param {} なし
 * @return {}  なし
 */
function FamilySettingPage() {
  const navigate = useNavigate();
  const {
    globalAccessToken,
    globalSelectPatient,
    globalEmailAddress,
    setGlobalFamilyInfo,
    globalLoginUserInfo
  } = useContext(AppContext);
  const [form] = Form.useForm();
  const [errors, setErrors] = useState({});
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [isRegist, setIsRegist] = useState(false);
  /**
   * コンポーネントがマウントされた時
   */
  useEffect(() => {
    const patient = globalSelectPatient;
    form.setFieldsValue({
      lastName: patient?.kanjiLast,
      firstName: patient?.kanjiFirst,
      lastKana: patient?.kanaLast,
      firstKana: patient?.kanaFirst,
      birthDate: patient?.birthday,
      gender: patient?.sex,
    });

    if (patient == null) {
      setIsRegist(true);
    }
  }, []);

  /**
   * 戻るボタン押下時の処理
   * @param {} なし
   * @return {} なし
   */
  const handleBackClick = () => {
    navigate("/mypage/family-list");
  };

  /**
   * 更新ボタン押下時の処理
   * @param {} なし
   * @return {} なし
   */
  const handleConfirmClick = async () => {
    try {
      await form.validateFields();

      const formData = await form.getFieldsValue();

      const inputData = {
        familyMemberId: globalSelectPatient?.familyMemberId,
        kanjiLast: formData?.lastName,
        kanjiFirst: formData?.firstName,
        kanaLast: formData?.lastKana,
        kanaFirst: formData?.firstKana,
        birthday: dayjs(`${formData?.birthDate}`).format("YYYY-MM-DD"),
        sex: formData?.gender,
      };

      // 家族情報変更
      try {
        let data = "";
        if (globalSelectPatient != null) {
          data = await updateFamilyInfo(
            globalAccessToken,
            globalEmailAddress,
            inputData
          );
        } else {
          data = await registFamilyInfo(
            globalAccessToken,
            globalEmailAddress,
            inputData
          );
        }

        if (data.result.status === "OK") {
          //家族情報を取得してglobalfamilyinfoを更新
          const familyInfo = await getFamilyInfo(
            globalLoginUserInfo.userInfo.adb2cId,
            globalAccessToken
          );
          if (familyInfo.result.status === "OK") {
            setGlobalFamilyInfo(familyInfo.data.familyInfo);
            // 家族一覧に移動
            navigate("/mypage/family-list");
            showToast("家族情報を登録しました", "success");
          } else {
            // エラーメッセージセット
            showToast(familyInfo.result.error_message);
          }
        } else {
          // エラーメッセージセット
          showToast(data?.result?.error_message, "error");
        }
      } catch (error) {
        console.error("Error updateFamilyInfo:", error);
        showToast("家族情報登録に失敗しました", "error");
      }
    } catch (error) {
      const fieldErrors = error.errorFields.reduce((acc, field) => {
        acc[field.name[0]] = true;
        return acc;
      }, {});
      setErrors(fieldErrors);
      showToast("入力に不備があります。ご確認ください", "error");
    }
  };

  // ダイアログを開く
  const openDialog = () => setDialogOpen(true);

  // ダイアログを閉じる
  const closeDialog = () => setDialogOpen(false);

  /**
   * 削除ボタン押下時の処理
   * @param {} なし
   * @return {} なし
   */
  const handleDeleteFamilyInfoClick = async () => {
    openDialog(true);
  };

  /**
   * ダイアログのボタンがクリックされたときの処理
   * @param {number} buttonIndex - クリックされたボタンのインデックス
   */
  const handleButtonClick = async (buttonIndex) => {
    setDialogOpen(false);

    if (buttonIndex === 0) {
      // 家族情報削除
      try {
        const data = await deleteFamilyInfo(
          globalAccessToken,
          globalEmailAddress,
          globalSelectPatient?.familyMemberId
        );
        if (data.result.status === "OK") {
          // 家族一覧に移動
          //家族情報を取得してglobalfamilyinfoを更新
          const familyInfo = await getFamilyInfo(
            globalLoginUserInfo.userInfo.adb2cId,
            globalAccessToken
          );
          if (familyInfo.result.status === "OK") {
            setGlobalFamilyInfo(familyInfo.data.familyInfo);
            // 家族一覧に移動
            navigate("/mypage/family-list");
            showToast("家族情報を削除しました", "success");
          } else {
            // エラーメッセージセット
            showToast(familyInfo.result.error_message);
          }
        } else {
          // 家族一覧に移動
          // エラーメッセージセット
          showToast(data?.result?.error_message, "error");
          navigate("/mypage/family-list");
        }
      } catch (error) {
        showToast("家族情報の削除に失敗しました", "error");
        console.error("Error deleteFamilyInfo:", error);
      }
    }
  };

  const buttons = [
    {
      label: "削除",
      width: "120px",
      type: "primary-red",
      onClick: handleButtonClick,
    },
    {
      label: "戻る",
      width: "40px",
      type: "secondary-white",
      onClick: handleButtonClick,
    },
  ];

  return (
    <div className="family-setting">
      <div className="main-area">
        <div className="title">家族情報登録</div>
        <div className="detail"></div>
        <div className="form">
          <Form
            form={form}
            name="registration"
            layout="vertical"
            initialValues={{ remember: true }}
          >
            <div>
              <ReservationInputForm
                form={form}
                errors={errors}
                setErrors={setErrors}
                formSetting={{
                  cardNo: {
                    visible: false,
                  },
                  email: {
                    visible: false,
                    required: false,
                  },
                  phoneNumber: {
                    visible: false,
                    required: false,
                  },
                  address: {
                    visible: false,
                    required: false,
                  },
                }}
              />
              <Form.Item>
                <GeneralButton
                  buttonLabel={"登録"}
                  type={
                    Object.values(errors).some((error) => error)
                      ? "disabled"
                      : "primary-blue"
                  }
                  onClick={handleConfirmClick}
                />
              </Form.Item>
            </div>
          </Form>
        </div>
        <div className="general-buttons">
          <GeneralButton
            buttonLabel={"家族設定に戻る"}
            type={"secondary-white"}
            onClick={handleBackClick}
          />
          {!isRegist && (
            <GeneralButton
              buttonLabel={"削除"}
              type={"link-red"}
              onClick={handleDeleteFamilyInfoClick}
            />
          )}
        </div>
      </div>
      <Dialog
        title={"家族登録削除"}
        isOpen={isDialogOpen}
        onClose={closeDialog}
        buttons={buttons}
      >
        <div className="dialog-normal-area">
          {"家族情報を削除します。よろしいですか？"}
        </div>
      </Dialog>
    </div>
  );
}

export default FamilySettingPage;
